export default "__VITE_ASSET__CpHMJN4F__"